module.exports = __webpack_public_path__ + "static/media/trainingTask.fd96ee7e.png";